import { render, staticRenderFns } from "./gzzoc-ckd.vue?vue&type=template&id=adf64268&scoped=true&lang=pug&"
import script from "./gzzoc-ckd.vue?vue&type=script&lang=js&"
export * from "./gzzoc-ckd.vue?vue&type=script&lang=js&"
import style0 from "./gzzoc-ckd.vue?vue&type=style&index=0&id=adf64268&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf64268",
  null
  
)

export default component.exports